import { render, staticRenderFns } from "./CodePreview.vue?vue&type=template&id=409a2282&scoped=true"
import script from "./CodePreview.vue?vue&type=script&lang=js"
export * from "./CodePreview.vue?vue&type=script&lang=js"
import style0 from "./CodePreview.vue?vue&type=style&index=0&id=409a2282&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409a2282",
  null
  
)

export default component.exports